import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Typography } from '~/components/common/Typography'
import { cn } from '@nextui-org/react'
import {
  SegmentControls,
  SegmentControlsList,
  SegmentControlsTrigger
} from '~/components/common/SegmentControls'

// Stats Card Icons - from Figma design
const TaskListIcon = () => (
  <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M5.25 3.5H9.625' stroke='#5B5BD5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M5.25 7H9.625' stroke='#5B5BD5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M5.25 10.5H9.625' stroke='#5B5BD5' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M2.91667 2.91667L3.5 3.5L4.66667 2.33333'
      stroke='#5B5BD5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.91667 6.41667L3.5 7L4.66667 5.83333'
      stroke='#5B5BD5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.91667 9.91667L3.5 10.5L4.66667 9.33333'
      stroke='#5B5BD5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

const CheckCircleIcon = () => (
  <svg width='14' height='14' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.83333 1.16667C3.256 1.16667 1.16667 3.256 1.16667 5.83333C1.16667 8.41066 3.256 10.5 5.83333 10.5C8.41066 10.5 10.5 8.41066 10.5 5.83333C10.5 3.256 8.41066 1.16667 5.83333 1.16667ZM0 5.83333C0 2.61167 2.61167 0 5.83333 0C9.05499 0 11.6667 2.61167 11.6667 5.83333C11.6667 9.05499 9.05499 11.6667 5.83333 11.6667C2.61167 11.6667 0 9.05499 0 5.83333ZM8.87081 4.20415L4.66667 8.40829L2.50419 6.24581L3.32915 5.42085L4.66667 6.75838L8.04585 3.37919L8.87081 4.20415Z'
      fill='#36A764'
    />
  </svg>
)

const ErrorCircleIcon = () => (
  <svg width='14' height='14' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.83333 1.16667C3.256 1.16667 1.16667 3.256 1.16667 5.83333C1.16667 8.41066 3.256 10.5 5.83333 10.5C8.41066 10.5 10.5 8.41066 10.5 5.83333C10.5 3.256 8.41066 1.16667 5.83333 1.16667ZM0 5.83333C0 2.61167 2.61167 0 5.83333 0C9.05499 0 11.6667 2.61167 11.6667 5.83333C11.6667 9.05499 9.05499 11.6667 5.83333 11.6667C2.61167 11.6667 0 9.05499 0 5.83333ZM3.20915 3.20915L5.83333 5.83333L3.20915 8.45751L4.03411 9.28247L6.65829 6.65829L9.28247 9.28247L10.1074 8.45751L7.48325 5.83333L10.1074 3.20915L9.28247 2.38419L6.65829 5.00837L4.03411 2.38419L3.20915 3.20915Z'
      fill='#D94B36'
    />
  </svg>
)

const DownloadIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8 10.6667V2.66675M8 10.6667L10.6667 8.00008M8 10.6667L5.33333 8.00008'
      stroke='black'
      strokeOpacity='0.88'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14 10.6667V13.3334H2V10.6667'
      stroke='black'
      strokeOpacity='0.88'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

const ChevronRightIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M6 12L10 8L6 4'
      stroke='rgba(0,0,0,0.45)'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

const ChevronDownIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M4 6L8 10L12 6'
      stroke='rgba(0,0,0,0.45)'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

const FileIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9.33333 2H4.66667C4.29867 2 4 2.29867 4 2.66667V13.3333C4 13.7013 4.29867 14 4.66667 14H11.3333C11.7013 14 12 13.7013 12 13.3333V5.33333L9.33333 2Z'
      stroke='rgba(0,0,0,0.45)'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.33333 2V5.33333H12'
      stroke='rgba(0,0,0,0.45)'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

interface ArtifactFile {
  name: string
  type: 'json' | 'md'
}

interface FlowFolder {
  name: string
  files: ArtifactFile[]
}

interface Artifact {
  title: string
  description: string
  files?: ArtifactFile[]
  folders?: FlowFolder[]
  expandable?: boolean
}

export function TestAgentResultScreen() {
  const navigate = useNavigate()
  const { uuid, workspaceUuid } = useParams<{ uuid: string; workspaceUuid: string }>()
  const [expandedFolders, setExpandedFolders] = useState<Set<string>>(new Set(['Mule flow 2']))
  const [activeTab, setActiveTab] = useState('results')

  // Mock data
  const results = {
    totalFlows: 6,
    passedFlows: 5,
    failedFlows: 1
  }

  const artifacts: Record<string, Artifact> = {
    summary: {
      title: 'Summary',
      description: 'High-level overview of test results',
      files: [
        { name: 'MuleSoft Project 20250810.json', type: 'json' },
        { name: 'Salesforce Integration 20250915.json', type: 'json' },
        { name: 'API Development 20251001.json', type: 'json' }
      ]
    },
    allFlows: {
      title: 'All Flows',
      description: 'Combined JSON of all tested flows.',
      expandable: true,
      folders: [
        {
          name: 'Mule flow 2',
          files: [
            { name: 'Salesforce Integration 20250915.json', type: 'json' },
            { name: 'Data Migration 20251001.json', type: 'json' },
            { name: 'API Documentation 20251618.md', type: 'md' }
          ]
        },
        { name: 'Mule flow 3', files: [] },
        { name: 'Mule flow 4', files: [] },
        { name: 'Mule flow 5', files: [] },
        { name: 'Mule flow 6', files: [] },
        { name: 'Mule flow 7', files: [] }
      ]
    },
    environment: {
      title: 'Environment',
      description: 'Config and variables used during the test.',
      files: [
        { name: 'MuleSoft Project 20250810.json', type: 'json' },
        { name: 'Salesforce Integration 20250915.json', type: 'json' },
        { name: 'Salesforce Integration 20250915.json', type: 'json' },
        { name: 'API Development 20251001.json', type: 'json' }
      ]
    },
    data: {
      title: 'Data (optional)',
      description: 'Test data for review or download.',
      files: [
        { name: 'MuleSoft Project 20250810.json', type: 'json' },
        { name: 'Salesforce Integration 20250915.json', type: 'json' }
      ]
    }
  }

  const toggleFolder = (folderName: string) => {
    setExpandedFolders(prev => {
      const next = new Set(prev)
      if (next.has(folderName)) {
        next.delete(folderName)
      } else {
        next.add(folderName)
      }
      return next
    })
  }

  const handleDownloadAll = () => {
    console.log('Download all artifacts')
    // TODO: Implement download all functionality
  }

  const handleDownloadArtifact = (artifactName: string) => {
    console.log('Download artifact:', artifactName)
    // TODO: Implement download artifact functionality
  }

  const handleTabChange = (value: string) => {
    setActiveTab(value)
    if (value === 'task') {
      // Navigate back to the task/confirmation screen
      // Use workspace route if no conversation UUID, otherwise use conversation route
      if (uuid) {
        navigate(`/c/${uuid}/integration-test`)
      } else if (workspaceUuid) {
        navigate(`/w/${workspaceUuid}?command=integration-test`)
      }
    }
  }

  return (
    <div className='relative flex min-h-screen flex-col items-center bg-[#FCFCFC] px-[319px] pt-[119px]'>
      {/* SegmentedControl - positioned 16px from top-right of page */}
      <div className='fixed right-[16px] top-[16px] z-10'>
        <SegmentControls value={activeTab} onValueChange={handleTabChange}>
          <SegmentControlsList>
            <SegmentControlsTrigger value='task'>Task</SegmentControlsTrigger>
            <SegmentControlsTrigger value='results'>Results</SegmentControlsTrigger>
          </SegmentControlsList>
        </SegmentControls>
      </div>

      {/* Main Content */}
      <div className='flex w-[801px] flex-col gap-[48px]'>
        {/* Testing Snapshot Section */}
        <section className='flex w-full flex-col'>
          {/* Section Title */}
          <div className='mb-[24px] flex h-[18px] flex-col items-start self-stretch px-[32px]'>
            <Typography
              fontFamily='geist'
              fontSize='bodyMd'
              fontWeight='semibold'
              className='text-[rgba(0,0,0,0.88)]'
              style={{ fontSize: '14px', fontWeight: 600, lineHeight: '18px' }}
            >
              Your Testing Snapshot
            </Typography>
          </div>

          {/* Stats Cards */}
          <div className='flex gap-[24px]'>
            {/* Total Flows Tested */}
            <div className='flex h-[90px] w-[251px] items-center gap-[10px] rounded-[24px] border border-[rgba(91,91,213,0.2)] bg-[#f7f7ff] px-[32px] py-[24px]'>
              <div className='flex flex-1 flex-col gap-[4px]'>
                <Typography
                  fontFamily='geist'
                  fontSize='bodySm'
                  fontWeight='medium'
                  className='text-[#2e1f36]'
                  style={{ fontSize: '12px', fontWeight: 500, lineHeight: '16px' }}
                >
                  Total Flows Tested
                </Typography>
                <Typography
                  fontFamily='geist'
                  fontSize='titleLg'
                  fontWeight='bold'
                  className='text-[#65558f]'
                  style={{ fontSize: '20px', fontWeight: 700, lineHeight: '22px' }}
                >
                  {results.totalFlows}
                </Typography>
              </div>
              <div className='flex size-[24px] shrink-0 items-center justify-center rounded-[96px] bg-[rgba(91,91,213,0.2)] p-[4px]'>
                <TaskListIcon />
              </div>
            </div>

            {/* Flow Passed */}
            <div className='flex h-[90px] w-[251px] items-center gap-[10px] rounded-[24px] border border-[rgba(91,91,213,0.2)] bg-[#f7f7ff] px-[32px] py-[24px]'>
              <div className='flex flex-1 flex-col gap-[4px]'>
                <Typography
                  fontFamily='geist'
                  fontSize='bodySm'
                  fontWeight='medium'
                  className='text-[#2e1f36]'
                  style={{ fontSize: '12px', fontWeight: 500, lineHeight: '16px' }}
                >
                  Flow Passed
                </Typography>
                <Typography
                  fontFamily='geist'
                  fontSize='titleLg'
                  fontWeight='bold'
                  className='text-[#65558f]'
                  style={{ fontSize: '20px', fontWeight: 700, lineHeight: '22px' }}
                >
                  {results.passedFlows}
                </Typography>
              </div>
              <div className='flex size-[24px] shrink-0 items-center justify-center rounded-[96px] bg-[rgba(54,167,100,0.2)] p-[4px]'>
                <CheckCircleIcon />
              </div>
            </div>

            {/* Flow Failed */}
            <div className='flex h-[90px] w-[251px] items-center gap-[10px] rounded-[24px] border border-[rgba(91,91,213,0.2)] bg-[#f7f7ff] px-[32px] py-[24px]'>
              <div className='flex flex-col gap-[4px] flex-1'>
                <Typography
                  fontFamily='geist'
                  fontSize='bodySm'
                  fontWeight='medium'
                  className='text-[#2e1f36]'
                  style={{ fontSize: '12px', fontWeight: 500, lineHeight: '16px' }}
                >
                  Flow Failed
                </Typography>
                <Typography
                  fontFamily='geist'
                  fontSize='titleLg'
                  fontWeight='bold'
                  className='text-[#65558f]'
                  style={{ fontSize: '20px', fontWeight: 700, lineHeight: '22px' }}
                >
                  {results.failedFlows}
                </Typography>
              </div>
              <div className='flex size-[24px] shrink-0 items-center justify-center rounded-[96px] bg-[rgba(234,70,45,0.1)] p-[4px]'>
                <ErrorCircleIcon />
              </div>
            </div>
          </div>
        </section>

        {/* Detailed Artifacts Section */}
        <section className='flex w-full flex-col'>
          {/* Section Header */}
          <div className='mb-[52px] flex h-[36px] items-center justify-between px-[32px]'>
            <Typography
              fontFamily='geist'
              fontSize='bodyMd'
              fontWeight='semibold'
              className='text-[rgba(0,0,0,0.88)]'
              style={{ fontSize: '14px', fontWeight: 600, lineHeight: '18px' }}
            >
              Detailed Artifacts Generated
            </Typography>
            <button
              type='button'
              onClick={handleDownloadAll}
              className={cn(
                'flex h-[36px] w-[145px] cursor-pointer items-center justify-center gap-[8px]',
                'rounded-[12px] border border-[rgba(0,0,0,0.12)] bg-transparent px-[16px] py-[8px]',
                'transition-colors hover:bg-[rgba(0,0,0,0.02)]'
              )}
            >
              <DownloadIcon />
              <Typography
                fontFamily='geist'
                fontSize='bodyMd'
                fontWeight='medium'
                className='whitespace-nowrap text-[rgba(0,0,0,0.88)]'
                style={{ fontSize: '14px', fontWeight: 500, lineHeight: '22px' }}
              >
                Download All
              </Typography>
            </button>
          </div>

          {/* Artifacts Container */}
          <div className='flex flex-col gap-[32px]'>
            {/* Summary Artifact */}
            <div className='flex flex-col gap-[8px] rounded-[24px] border border-[#eaeaea] pb-[16px]'>
              {/* Card Header */}
              <div className='flex items-center gap-[12px] rounded-tl-[24px] rounded-tr-[24px] border-b border-[#eaeaea] bg-[rgba(189,189,189,0.08)] pl-[32px] pr-[16px] py-[16px]'>
                <div className='flex flex-1 flex-col gap-[4px]'>
                  <Typography
                    fontFamily='geistMono'
                    fontSize='bodyMd'
                    fontWeight='semibold'
                    className='text-[rgba(36,24,42,0.92)]'
                    style={{ fontSize: '15px', fontWeight: 600, lineHeight: 'normal' }}
                  >
                    {artifacts.summary.title}
                  </Typography>
                  <Typography
                    fontFamily='geist'
                    fontSize='bodySm'
                    fontWeight='medium'
                    className='text-[rgba(0,0,0,0.45)]'
                    style={{ fontSize: '12px', fontWeight: 500, lineHeight: '16px' }}
                  >
                    {artifacts.summary.description}
                  </Typography>
                </div>
                <button
                  type='button'
                  onClick={() => handleDownloadArtifact('summary')}
                  className='flex h-[36px] cursor-pointer items-center justify-center rounded-[12px] bg-transparent px-[16px] py-[8px] transition-colors hover:bg-[rgba(0,0,0,0.04)]'
                >
                  <DownloadIcon />
                </button>
              </div>

              {/* File List */}
              <div className='flex flex-col'>
                {artifacts.summary.files?.map((file, index) => (
                  <div key={index} className='flex h-[48px] items-center px-[24px] py-[8px]'>
                    <div className='flex size-[32px] shrink-0 items-center justify-center overflow-clip rounded-[4px] p-[4px]'>
                      <FileIcon />
                    </div>
                    <Typography
                      fontFamily='geist'
                      fontSize='bodyMd'
                      fontWeight='medium'
                      className='flex-1 text-[rgba(0,0,0,0.88)]'
                      style={{ fontSize: '14px', fontWeight: 500, lineHeight: '22px' }}
                    >
                      {file.name}
                    </Typography>
                  </div>
                ))}
              </div>
            </div>

            {/* All Flows Artifact */}
            <div className='flex flex-col gap-[8px] rounded-[24px] border border-[#eaeaea] pb-[16px]'>
              {/* Card Header */}
              <div className='flex items-center gap-[12px] rounded-tl-[24px] rounded-tr-[24px] border-b border-[#eaeaea] bg-[rgba(189,189,189,0.08)] pl-[32px] pr-[16px] py-[16px]'>
                <div className='flex flex-1 flex-col gap-[4px]'>
                  <Typography
                    fontFamily='geistMono'
                    fontSize='bodyMd'
                    fontWeight='semibold'
                    className='text-[rgba(36,24,42,0.92)]'
                    style={{ fontSize: '15px', fontWeight: 600, lineHeight: 'normal' }}
                  >
                    {artifacts.allFlows.title}
                  </Typography>
                  <Typography
                    fontFamily='geist'
                    fontSize='bodySm'
                    fontWeight='medium'
                    className='text-[rgba(0,0,0,0.45)]'
                    style={{ fontSize: '12px', fontWeight: 500, lineHeight: '16px' }}
                  >
                    {artifacts.allFlows.description}
                  </Typography>
                </div>
                <button
                  type='button'
                  onClick={() => handleDownloadArtifact('allFlows')}
                  className='flex h-[36px] cursor-pointer items-center justify-center rounded-[12px] bg-transparent px-[16px] py-[8px] transition-colors hover:bg-[rgba(0,0,0,0.04)]'
                >
                  <DownloadIcon />
                </button>
              </div>

              {/* Expandable Folders */}
              <div className='flex flex-col'>
                {artifacts.allFlows.folders?.map((folder, index) => (
                  <div key={index}>
                    {/* Folder Header */}
                    <button
                      type='button'
                      onClick={() => toggleFolder(folder.name)}
                      className='flex h-[48px] w-full cursor-pointer items-center bg-transparent pl-[24px] pr-0 py-[8px] text-left transition-colors hover:bg-[rgba(0,0,0,0.02)]'
                    >
                      <div className='flex h-[32px] w-[32px] items-center justify-center'>
                        {expandedFolders.has(folder.name) ? (
                          <ChevronDownIcon />
                        ) : (
                          <ChevronRightIcon />
                        )}
                      </div>
                      <Typography
                        fontFamily='geist'
                        fontSize='bodyMd'
                        fontWeight='medium'
                        className='text-[rgba(0,0,0,0.88)]'
                        style={{ fontSize: '14px', fontWeight: 500, lineHeight: '22px' }}
                      >
                        {folder.name}
                      </Typography>
                    </button>

                    {/* Nested Files */}
                    {expandedFolders.has(folder.name) && folder.files.length > 0 && (
                      <div className='flex flex-col pl-[16px]'>
                        {folder.files.map((file, fileIndex) => (
                          <div
                            key={fileIndex}
                            className='flex h-[48px] items-center pl-[32px] pr-0 py-[13px]'
                          >
                            <div className='flex h-[32px] w-[32px] items-center justify-center'>
                              <FileIcon />
                            </div>
                            <Typography
                              fontFamily='geist'
                              fontSize='bodyMd'
                              fontWeight='medium'
                              className='text-[rgba(0,0,0,0.88)]'
                              style={{ fontSize: '14px', fontWeight: 500, lineHeight: '22px' }}
                            >
                              {file.name}
                            </Typography>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Environment Artifact */}
            <div className='flex flex-col gap-[8px] rounded-[24px] border border-[#eaeaea] pb-[16px]'>
              {/* Card Header */}
              <div className='flex items-center gap-[12px] rounded-tl-[24px] rounded-tr-[24px] border-b border-[#eaeaea] bg-[rgba(189,189,189,0.08)] pl-[32px] pr-[16px] py-[16px]'>
                <div className='flex flex-1 flex-col gap-[4px]'>
                  <Typography
                    fontFamily='geistMono'
                    fontSize='bodyMd'
                    fontWeight='semibold'
                    className='text-[rgba(36,24,42,0.92)]'
                    style={{ fontSize: '15px', fontWeight: 600, lineHeight: 'normal' }}
                  >
                    {artifacts.environment.title}
                  </Typography>
                  <Typography
                    fontFamily='geist'
                    fontSize='bodySm'
                    fontWeight='medium'
                    className='text-[rgba(0,0,0,0.45)]'
                    style={{ fontSize: '12px', fontWeight: 500, lineHeight: '16px' }}
                  >
                    {artifacts.environment.description}
                  </Typography>
                </div>
                <button
                  type='button'
                  onClick={() => handleDownloadArtifact('environment')}
                  className='flex h-[36px] cursor-pointer items-center justify-center rounded-[12px] bg-transparent px-[16px] py-[8px] transition-colors hover:bg-[rgba(0,0,0,0.04)]'
                >
                  <DownloadIcon />
                </button>
              </div>

              {/* File List - node 674:65240 wrapper at x=16 */}
              <div className='flex flex-col pl-[16px]'>
                {artifacts.environment.files?.map((file, index) => (
                  <div key={index} className='flex h-[48px] items-center pl-[8px] pr-0 py-[13px]'>
                    <div className='flex h-[32px] w-[32px] items-center justify-center'>
                      <FileIcon />
                    </div>
                    <Typography
                      fontFamily='geist'
                      fontSize='bodyMd'
                      fontWeight='medium'
                      className='text-[rgba(0,0,0,0.88)]'
                      style={{ fontSize: '14px', fontWeight: 500, lineHeight: '22px' }}
                    >
                      {file.name}
                    </Typography>
                  </div>
                ))}
              </div>
            </div>

            {/* Data Artifact */}
            <div className='flex flex-col gap-[8px] rounded-[24px] border border-[#eaeaea] pb-[16px]'>
              {/* Card Header */}
              <div className='flex items-center gap-[12px] rounded-tl-[24px] rounded-tr-[24px] border-b border-[#eaeaea] bg-[rgba(189,189,189,0.08)] pl-[32px] pr-[16px] py-[16px]'>
                <div className='flex flex-1 flex-col gap-[4px]'>
                  <Typography
                    fontFamily='geistMono'
                    fontSize='bodyMd'
                    fontWeight='semibold'
                    className='text-[rgba(36,24,42,0.92)]'
                    style={{ fontSize: '15px', fontWeight: 600, lineHeight: 'normal' }}
                  >
                    {artifacts.data.title}
                  </Typography>
                  <Typography
                    fontFamily='geist'
                    fontSize='bodySm'
                    fontWeight='medium'
                    className='text-[rgba(0,0,0,0.45)]'
                    style={{ fontSize: '12px', fontWeight: 500, lineHeight: '16px' }}
                  >
                    {artifacts.data.description}
                  </Typography>
                </div>
                <button
                  type='button'
                  onClick={() => handleDownloadArtifact('data')}
                  className='flex h-[36px] cursor-pointer items-center justify-center rounded-[12px] bg-transparent px-[16px] py-[8px] transition-colors hover:bg-[rgba(0,0,0,0.04)]'
                >
                  <DownloadIcon />
                </button>
              </div>

              {/* File List */}
              <div className='flex flex-col'>
                {artifacts.data.files?.map((file, index) => (
                  <div key={index} className='flex h-[48px] items-center px-[24px] py-[8px]'>
                    <div className='flex size-[32px] shrink-0 items-center justify-center overflow-clip rounded-[4px] p-[4px]'>
                      <FileIcon />
                    </div>
                    <Typography
                      fontFamily='geist'
                      fontSize='bodyMd'
                      fontWeight='medium'
                      className='flex-1 text-[rgba(0,0,0,0.88)]'
                      style={{ fontSize: '14px', fontWeight: 500, lineHeight: '22px' }}
                    >
                      {file.name}
                    </Typography>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default TestAgentResultScreen
